import { CommonModule } from '@angular/common'
import { ComponentsModule } from '../../../components/components.module';
import { CustomImageLinkBoxComponent } from './components/custom-image-link-box/custom-image-link-box.component'
import { CustomLinksWrapperComponent } from './components/custom-links-wrapper/custom-links-wrapper.component';
import { ElementCardsDirectiveModule } from '@toro/common/shared/directives/element-cards/element-cards.module';
import { MarketCardMobileComponent } from '../../../components/cards/market-card-mobile/market-card-mobile.component';
import { MarketExplorerComponent } from './market-explorer.component';
import { ModalWelcomePiModule } from '@toro/common/shared/components/modal-welcome-pi/modal-welcome-pi.module';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '@toro/common/shared/components';
import { marketExplorerRoutes } from './market-explorer.routes';

@NgModule({
    imports: [
        marketExplorerRoutes,
        CommonModule,
        ComponentsModule,
        SvgIconModule,
        ElementCardsDirectiveModule,
        ModalWelcomePiModule,
    ],
    declarations: [
        CustomImageLinkBoxComponent,
        CustomLinksWrapperComponent,
        MarketExplorerComponent,
        MarketCardMobileComponent,
    ],
})
export class MarketExplorerModule {}
